import { LessonCourseDefaultThumbnail } from '@/constant/imgImport';
import { Skeleton } from '@mui/material';
import { Divider } from 'design-system/components/Divider';
import { Typography } from 'design-system/components/Typography';
import { twMerge } from 'tailwind-merge';
import ThumbnailDisplay from '../components/ThumbnailDisplay';
import { TDoccenLibraryDocumentFileSkeleton } from '../type';

const DocumentFileGridViewType1Skeleton = ({
  gridView,
  type,
  ...divProps
}: TDoccenLibraryDocumentFileSkeleton) => {
  return (
    <div
      {...divProps}
      className={twMerge(
        'w-[212.67px] animate-pulse space-y-2 rounded-lg border border-Other/Outlinedborder-stroke bg-Other/White p-2 pb-3 transition-all ease-linear',
        divProps.className
      )}
    >
      <div className="flex h-[160px] w-full items-center justify-center">
        <ThumbnailDisplay
          thumbnail={LessonCourseDefaultThumbnail}
          fileType={'PDF'}
        />
      </div>
      <Divider type="horizontal" />
      <Typography
        variant="input-label"
        className="text-Text/Lightbackground/Secondary"
      >
        Tài liệu
      </Typography>
      <Skeleton variant="rounded" width={'100%'} height={'20px'} />
      <Skeleton variant="rounded" width={'100%'} height={'12px'} />
      <Skeleton variant="rounded" width={'100%'} height={'12px'} />
    </div>
  );
};

export default DocumentFileGridViewType1Skeleton;
